import { Avatar, Box, Typography } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { convertPrice } from "utils/currency.util";
import useQuery from "utils/router.util";
import { getUTCYMD } from "utils/timestamp.util";

const RentalBookingRequestItem = ({
  id,
  user,
  created_at,
  booking_items,
  from_date,
  to_date,
  booking_payments,
}: any) => {
  const query = useQuery();
  const bId = query.get("booking") ? Number(query.get("booking")) : null;
  const navigate = useNavigate();

  const getNavigationLink = () => {
    const type = query.get("type");
    const params = new URLSearchParams({
      ...(type ? { type: type } : {}),
      ...(id ? { booking: id } : {}),
    });

    return `/rental?${params.toString()}`;
  };

  return (
    <Box
      sx={{
        background: bId === id ? "#E1FFA2" : "#FFF",
        cursor: "pointer",
        borderRight: bId === id ? "4px solid #6E8C20" : "4px solid #FFFFFF",
      }}
      component="div"
      onClick={() => navigate(getNavigationLink())}
    >
      <Box
        sx={{
          marginLeft: {
            sm: "15px",
            xs: "15px",
            md: "60px",
            lg: "60px",
            xl: "60px",
          },
          padding: "15px 0 15px 0",
          borderBottom: "1px solid #E2E2E2",
          overflow: "hidden",
        }}
      >
        <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Avatar
            src={user?.image_url}
            sx={{ height: "56px", width: "56px" }}
          />
          <Box>
            <Typography
              sx={{
                color: "#323232",
                fontSize: "18px",
                fontWeight: 600,
                lineHeight: "30px",
                width: "100%",

                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
                display: "-webkit-box",
              }}
            >
              {user?.name}
            </Typography>
            <Typography
              sx={{
                color: "#323232",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "18px",
              }}
            >
              Order Date - {moment(created_at).format("MMM DD hh:mm a")}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", pr: "10px" }}>
          <Typography
            sx={{
              color: "#323232",
              fontWeight: 600,
              fontSize: "18px",
              lineHeight: "26px",

              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
              my: "15px",
              flex: 1,
              // maxWidth: "70%",
            }}
          >
            {booking_items?.[0]?.listings?.listing_name}
            &nbsp;&nbsp;
          </Typography>
          {booking_items.length > 1 && (
            <Typography
              sx={{
                color: "#307AFF",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              +{booking_items.length - 1} more
            </Typography>
          )}
        </Box>

        <BookingFooter
          id={id}
          from_date={from_date}
          to_date={to_date}
          price={booking_payments?.[0]?.total}
          selected={bId === id}
        />
      </Box>
    </Box>
  );
};

export default RentalBookingRequestItem;

const BookingFooter = ({ id, from_date, to_date, price, selected }: any) => {
  return (
    <Box sx={{ display: "flex", pr: "20px", justifyContent: "space-between" }}>
      <Box>
        <Typography
          sx={{
            color: selected ? "#323232A9" : "#A2A2A2A9",
            fontSize: "14px",
            lineHeight: "18px",
            fontWeight: 400,
          }}
        >
          Order ID
        </Typography>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "28px",
            color: "#323232",
          }}
        >
          #{id}
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{
            color: selected ? "#323232A9" : "#A2A2A2A9",
            fontSize: "14px",
            lineHeight: "18px",
            fontWeight: 400,
          }}
        >
          Booking For
        </Typography>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "28px",
            color: "#323232",
          }}
        >
          {moment(getUTCYMD(from_date)).format("MMM DD")} -
          {moment(getUTCYMD(to_date)).format("MMM DD")}
        </Typography>
      </Box>
      <Box>
        <Typography
          sx={{
            color: selected ? "#323232A9" : "#A2A2A2A9",
            fontSize: "14px",
            lineHeight: "18px",
            fontWeight: 400,
          }}
        >
          Order Amount
        </Typography>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "28px",
            color: "#323232",
          }}
        >
          {convertPrice(price)}
        </Typography>
      </Box>
    </Box>
  );
};
